export default __webpack_public_path__ + "static/media/reactlogo.1d84ea42.png";